import ApplicationController from '../application_controller.js'

/*
 * Transfer to Invoice
 */

export default class TransferToInvoiceController extends ApplicationController {

  selectInvoice(e) {
    this.enableSubmit()
  }

  clickCheck(e) {
    this.enableSubmit()
  }

  select_deselect(e) {
    e.target.closest("table").querySelectorAll(".record_selector").forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
    this.enableSubmit()
  }

  enableSubmit() {
    var can = false

    this.element.closest("form").querySelectorAll(".record_selector").forEach(e => {
      if (e.checked) {
        can = true
      }
    })

    can = can && this.element.closest("form").querySelector("#destination_invoice_id").selectedIndex > 0
    this.element.closest("form").querySelector("input[type=submit]").disabled = !can
  }
}